<template>
  <div class="device-maintenance-records">
    <div class="table-bd">
      <custom-table
        :data="tableList"
        :column="tableColumn"
        :max-height="500"
        @filter="filterChange"
        @sort="sortChange"
        :slots="['workOrderCode']"
      >
        <template v-slot:workOrderCode="scope">
          <span class="cell-link" @click="toOrderDetail(scope.row)">{{ scope.row.workOrderCode }}</span>
        </template>
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page
        :total="totalRows"
        :page="formSearch.pageNum"
        :size="formSearch.pageSize"
        @change="onPageChange"
      ></custom-page>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import customTable from '@/components/customTable.vue';
import apis from '@/utils/apis.js';

export default {
  components: {
    customTable
  },
  props: {
    times: [Array, String],
    deviceInfo: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      tableCode: 'device_maintenance_records',
      formSearch: {
        pageSize: 20,
        pageNum: 1,
        search: '',
        orderBy: '',
        orderType: '',
        deviceId: '',
        workOrderType: '20'

      },
      tableList: [],
      totalRows: null
    };
  },
  mounted() {
    this.formSearch.deviceId = this.deviceInfo.deviceId;
    this.getTableColumn();
    this.getTableList();
  },
  methods: {
    // 跳转工单详情
    toOrderDetail(row, options = {}) {
      this.jump('/workorder/workOrderDetail', {
        orderType: 'workOrder',
        caseOrderType: row.workOrderType,
        caseOrderId: row.caseOrderId,
        workOrderId: row.workOrderId,
        ...options,
      });
    },
    getTableList() {
      this.$getJSON(apis.DeviceResumeWorkOrderPage, this.getReqData()).then(
        (res) => {
          this.tableList = res.data.list;
          this.totalRows = res.data.total;
        }
      );
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    getReqData() {
      return {
        ...this.formSearch,
        startDate:
          this.times && this.times[0]
            ? `${moment(this.times[0]).format('YYYY-MM-DD')} 00:00:00`
            : '',
        endDate:
          this.times && this.times[1]
            ? `${moment(this.times[1]).format('YYYY-MM-DD')} 00:00:00`
            : ''
      };
    }
  }
};
</script>

<style></style>
